/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import DehazeIcon from "@material-ui/icons/Dehaze";
import { LanguageDropdownMenu } from "components/common/LanguageDropdownMenu";
import { HeaderCartButton } from "components/header/HeaderCartButton";
import { HeaderLoginButton } from "components/header/HeaderLoginButton";
import { BellNotification } from "containers/account/notification/HeaderNotification";
import React from "react";
import { Link } from "react-router-dom";
import { changeStyleWithHosting } from "utility/hosting";

import { HeaderSearch } from "./HeaderSearch";

type Props = {
  uid: string;
  userEmail: string | undefined;
  // currentLang: string;
  isEmptyCart: boolean;
  isDisplayLogo: boolean;
  domainLogo: JSX.Element;
  homeLink: string;
  HeaderMenuItems: { name: string; link: string; display: boolean }[];
  // handleChangeLang: (
  //   event: React.ChangeEvent<{ name?: string; value: string }>
  // ) => void;
  toggleSideMenu: () => void;
  toggleMyCart: () => void;
  toggleLoginMethod: () => void;
};
export const HeaderPcDisplay: React.FC<Props> = (props) => {
  const classesHeaderForPc = headerDesignForPc();
  const { textColor, svgColor } =
    changeStyleWithHosting().commonSettings.header;

  return (
    <header css={classesHeaderForPc.header}>
      <div css={classesHeaderForPc.container}>
        <div css={classesHeaderForPc.flexLeftSideLayout}>
          <DehazeIcon
            htmlColor="#fff"
            fontSize="default"
            onClick={props.toggleSideMenu}
          />
          <h1 className="spwnLogo">
            <Link to={props.homeLink}>{props.domainLogo}</Link>
          </h1>
        </div>

        <div css={classesHeaderForPc.flexRightSideLayout}>
          <ul>
            {props.HeaderMenuItems.filter((el) => el.display === true).map(
              (el) => {
                return (
                  <li key={el.link}>
                    <Link to={el.link}>{el.name}</Link>
                  </li>
                );
              }
            )}
            {
              <li>
                <LanguageDropdownMenu />
              </li>
            }
          </ul>
          <HeaderSearch />
          {props.uid ? (
            <React.Fragment>
              <BellNotification />
              <HeaderCartButton
                iconColor={textColor}
                isEmptyCart={props.isEmptyCart}
                onClick={props.toggleMyCart}
              />
            </React.Fragment>
          ) : (
            <HeaderLoginButton
              iconColor={svgColor}
              onClick={props.toggleLoginMethod}
            />
          )}
        </div>
      </div>
    </header>
  );
};

const headerDesignForPc = () => {
  const { textColor } = changeStyleWithHosting().commonSettings.header;
  const { accentColor } = changeStyleWithHosting().baseStyles;

  return {
    header: css`
      position: relative;
      display: block;
      width: 100%;
      max-width: 1800px;
      margin: 0 auto;
      z-index: 900;
    `,
    container: css`
      display: flex;
      justify-content: space-between;
      width: 95%;
      padding: 15px 0px;
      margin: 0 auto;
    `,
    flexLeftSideLayout: css`
      display: flex;
      align-items: center;
      svg {
        display: block;
        margin-right: 24px;
        fill: ${textColor};
        cursor: pointer;
      }
      h1 {
        width: auto;
        height: 20px;
        img {
          height: 100%;
        }
      }
    `,
    flexRightSideLayout: css`
      display: flex;
      align-items: center;
      ul {
        display: grid;
        grid-template-columns: max-content max-content max-content max-content max-content;
        gap: 16px;
        li {
          display: inline-flex;
          align-items: center;
          font-size: 14px;
          font-weight: bold;
          a {
            color: ${textColor};
            &:hover {
              color: ${accentColor};
            }
          }
        }
      }
      #badge {
        margin-right: 10px;
      }
      #search {
        margin-right: 10px;
      }
      #bell svg {
        fill: ${textColor};
        cursor: pointer;
      }
    `,
  };
};
